import axios from 'axios';
import { url } from '../../../env';

const headers = () => ({
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
});

export const fetchAlerts = (params = {}) =>
    axios.get(`${url}/alerts`, { params, headers: headers() });

export const fetchUnreadCount = () =>
    axios.get(`${url}/alerts/unread-count`, { headers: headers() });

export const markAlertSeen = (id) =>
    axios.post(`${url}/alerts/${id}/seen`, {}, { headers: headers() });

export const ignoreAlert = (id) =>
    axios.post(`${url}/alerts/${id}/ignore`, {}, { headers: headers() });

export const silenceAlert = (id, hours) =>
    axios.post(`${url}/alerts/${id}/silence`, { hours }, { headers: headers() });

export const resolveAlert = (id) =>
    axios.post(`${url}/alerts/${id}/resolve`, {}, { headers: headers() });
